import React from "react";
import Pill from "carbon-react/lib/components/pill";

const UserEmailVerifiedPill = (props) => {
  return (
    <>
      {props.user.emailVerified === true ? (
        <Pill pillRole="status" colorVariant="positive" fill>
          Verified
        </Pill>
      ) : (
        <Pill pillRole="status" colorVariant="warning" fill>
          Not verified
        </Pill>
      )}
    </>
  );
};

export default UserEmailVerifiedPill;
